import clsx from "clsx";
import LoadingWithText from "./LoadingWithText";

const LoadingWithTextPage: React.FC = () => {
  return (
    <div
      className={clsx([
        "flex",
        "justify-center",
        "w-full",
        "items-center",
        "flex-grow",
        "md:mt-0",
      ])}
    >
      <LoadingWithText />
    </div>
  );
};

export default LoadingWithTextPage;
